import { deviceService } from "core";
import { DeviceType } from "core/features/device/enums/device-type.enum";
import { PageFooterComponent } from "front-end/components/page/page-footer.component";
import { PageHeaderComponent } from "front-end/components/page/page-header.component";

export class PageService {
    private _currentContext: JQuery<Document> = $();

    private _pageHeader: PageHeaderComponent = null;
    private _pageFooter: PageFooterComponent = null;

    public scroll(target: JQuery): void {
        const targetTopOffset = target.offset()?.top;
        if (!targetTopOffset) {
            throw new Error("Offset was undefined");
        }

        const additionalOffset = 20; // for better user experience

        $("html").animate({
            scrollTop: targetTopOffset - this._pageHeader.getHeight() - additionalOffset
        }, 100);
    }

    private handleDeviceUpdate(isMobile: boolean): void {
        if (isMobile) {
            this._pageHeader.updateStyles();
        }
        this._pageHeader.IsMobile = isMobile;
    }

    private handleAnchors(): void {
        const anchor = window.location.hash;
        if (anchor) {
            const target = $(anchor);

            this.scroll(target);
        }
    }

    private parseContext(): void {
        const pageHeaderContext = $(PageHeaderComponent.SELECTOR, this._currentContext);
        this._pageHeader = new PageHeaderComponent();
        this._pageHeader.init(pageHeaderContext);

        const pageFooterContext = $(PageFooterComponent.SELECTOR, this._currentContext);
        this._pageFooter = new PageFooterComponent();
        this._pageFooter.init(pageFooterContext);
    }

    private bindEvents(): void {
        deviceService.deviceType
            .subscribe((deviceType: DeviceType) => this.handleDeviceUpdate(deviceType === DeviceType.Mobile));

        this._pageHeader.on("menu/click").subscribe(() => this._pageFooter.updateStyles());

        $("a[href*='#']").on("click", () => {
            this.handleAnchors();
        });

        $(window).on("hashchange load", () => {
            this.handleAnchors();
        });
    }

    public init(): void {
        this._currentContext = $(document);

        this.parseContext();
        this.bindEvents();
        this.handleAnchors();
    }
}

export const pageService = new PageService();
